<template>
  <div
    id="app"
    :class="[
      $route.meta.heroMenu && dimensions.width > 768 ? 'hero-menu' : '',
      menuActive ? 'menu-active' : '',
      locale.ln
    ]">

    <!--
    <top-menu
      @region-selector-tapped="localeHasBeenSet = false"
      :mode="$route.meta.heroMenu && dimensions.width > 768 ? 'hero' : ''"
    ></top-menu>-->
    <!--<breadcrumbs v-if="!$route.meta.heroMenu" />-->

    <transition name="page-fade" appear>
      <div v-if="popupActive" class="overlay-pop">
        <div :class="[popup.css, 'overlay-pop--box']">
          <span class="closebtn" @click="togglePopup(false)"></span>
          <div :class="(popup.css || 'pop') + '--content'">
            <div
              v-if="popup.image"
              class="popup-image-bg"
              :style="
                `background-image: url('${$imageFolder + '/' + popup.image}')`
              "
            ></div>
            <!-- <img
              class="popup-image pb-s"
              v-if="popup.image"
              :src="`${$imageFolder}/${popup.image}`"
              :alt="popup.title"
              :title="popup.title"
            /> -->
            <!-- <img
              class="popup-image pb-s"
              v-if="popup.image"
              :src="`${$imageFolder}/${popup.image}`"
              :alt="popup.title"
              :title="popup.title"
            /> -->
            <div class="popup-info">
              <h3
                class="popup-title pb-s font-rg heading__2"
                v-text="popup.title"
              ></h3>
              <h4
                v-if="popup.sub_title"
                class="popup-title pb-s heading__4 text-gray-6"
                v-text="popup.sub_title"
              ></h4>

              <div
                v-if="popup.summary"
                class="popup-text text--m text-blue-6 pb-s italic"
                v-text="popup.summary"
              ></div>
              <div class="popup-text text--m" v-html="popup.content"></div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="overlay-down" appear>
      <keep-alive>
        <overlay v-if="overlay.active" />
      </keep-alive>
    </transition>
    <transition name="page-fade" appear>
      <overlay-gallery
        v-if="galIndex > -1"
        :children="gallery.children"
        :slider-index="galIndex"
      >
        <span class="closebtn" slot="close" @click="setGalleryIndex(-1)"></span>
      </overlay-gallery>
    </transition>

    <!-- collectionPicker -->
    <collection-picker v-if="collectItem > -1" :active-item="collectItem">
      <div slot="close" @click="setItemToCollect(-1)" class="btnClose">
        <i class="fal fa-times"></i>
      </div>
    </collection-picker>
    <!-- collectionViewer -->
    <collections-viewer v-if="collections.viewCollections">
      <div slot="close" @click="closeCollectionsViewer()" class="btnClose">
        <i class="fal fa-times"></i>
      </div>
    </collections-viewer>

    <router-view v-if="localeHasBeenSet" />    
    <site-footer
      v-if="localeHasBeenSet"
      @region-selector-tapped="localeHasBeenSet = false"
    ></site-footer>
    
    <transition name="fade-scale" appear>
      <i
        v-if="farEnough"
        @click="scrollToTop"
        title="Scroll to top"
        :class="['pointer', 'totop', 'fal', 'fa-chevron-square-up']"
      ></i>
    </transition>
    <transition name="page-fade" appear>
      <region-popup
        @local-selected="checkLocale(true)"
        v-if="!localeHasBeenSet"
      ></region-popup>
    </transition>
    <transition name="page-fade" appear>
      <ie-popup v-if="isOldIE"></ie-popup>
    </transition>
    <cookies-disclaimer
      v-if="localeHasBeenSet"
      :trigger-accept="shortAcceptCookies"
    ></cookies-disclaimer>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { storage, isIE, subdomain }         from "@/utils";

import SiteFooter         from "@/views/partials/SiteFooter.vue";
import CookiesDisclaimer  from "@/components/CookiesDisclaimer.vue";
import IePopup            from "@/components/IePopup.vue";
import TopMenu            from "@/components/TopMenu.vue";
import Breadcrumbs        from "@/components/Breadcrumbs.vue";

//import CollectionPicker from "@/components/CollectionPicker.vue";
//import CollectionsViewer from '@/components/CollectionsViewer.vue';
//import RegionPopup from "@/components/RegionPopup.vue";
//import OverlayGallery from "@/components/OverlayGallery.vue";
//import Overlay from "@/layout/Overlay.vue";

//Lazy loading components:
const OverlayGallery = ()    =>  import('./components/OverlayGallery.vue');
const Overlay = ()           =>  import('./layout/Overlay.vue');
const CollectionPicker = ()  =>  import('./components/CollectionPicker.vue');
const CollectionsViewer = () =>  import('./components/CollectionsViewer.vue');
const RegionPopup = ()       =>  import('./components/RegionPopup.vue');

//
export default {
  data() {
    return {
      collectItem: -1,
      galIndex: -1,
      code: "var Blob = 'abs'",
      pageHeight: 0,
      pageScrollTop: 0,
      // locale: null,
      localeHasBeenSet: true,
      keymap: {},
      keymapInt: -1,
      shortAcceptCookies: false
    };
  },
  watch: {
    "collections": {
      deep: true,
      handler() {
        console.log("this.collectItem >> ", this.collectItem)
          //alert("watch = "+this.collections.activeitem);
          this.collectItem = this.collections.activeitem;
        console.log("2 this.collectItem >> ", this.collectItem)
      }
    },
    getItemToCollect() {
      console.log("GET ITEM >> ", this.collections.activeitem);
    },
    "gallery.index"() {
      this.galIndex = this.gallery.index;
    },
    "$route.path"() {
      this.setGalleryChildren([]);
      this.scrollToTop();
    },
    localeString() {
      console.log("LOCALE CHANGED >> INIT MENU");
      // this.initMenu();
      this.initRawItems();
      this.initLocalizedUI();
    }
  },
  components: {
    CollectionPicker,
    CollectionsViewer,
    TopMenu,
    Overlay,
    SiteFooter,
    Breadcrumbs,
    OverlayGallery,
    RegionPopup,
    IePopup,
    CookiesDisclaimer
    //CollectionsViewer
  },
  created() {

    //--------------------------------------------------------------------
    //READ THE AUID + COLLECTION ITEMS FROM DB
      this.initAUID();  //auid init for collections data
      this.updateStoreCollection();
    //--------------------------------------------------------------------

    //this.initCollectionsList(); //read user collections
    this.initLocale();
    this.initResizeListener();
    this.initScrollListener();
    
    //this.addProductToCollection(111);
    //this.createCollection("123");

    // console.log("ISIE > ", isIE());
    // this.initCookieKeyListener();
  },
  // mounted() {
  //   this.setPageHeight();
  // },

  computed: {
    ...mapState([
      "overlay",
      "collections",
      "gallery",
      "dimensions",
      "popup",
      "localeRx",
      "locale"
    ]),
    ...mapGetters(["localeString", "localePath", "getItemToCollect"]),
    menuActive() {
      return this.overlay.active && this.overlay.type === "overlay-menu";
    },
    popupActive() {
      return this.$store.state.popup.active;
    },
    farEnough() {
      return this.pageScrollTop > 800;
    },
    isOldIE() {
      return isIE();
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   console.log('beforeRouteEnter');
  //   next(vm => {
  //     // access to component instance via `vm`
  //     console.log('beforeRouteEnter > ', to, " :: ", vm);
  //   })
  // },

  methods: {  
    isPatientPage() {
	  	  //var routePart = this.$route.path.toLowerCase().indexOf('/patient');
        var __subdomain = subdomain();
  		  //in case of /Patient or de-de/Patient
      	//return routePart ===0 || routePart === 6 || __subdomain === 'patient'
        return  __subdomain === 'patient' || __subdomain === 'lab'
    },
    ...mapActions([
      "initAUID",
      "initCollectionsList",
      "setLocale",
      // "initMenu",
      "initRawItems",
      "initLocalizedUI",
      "setDimensions",
      "setGalleryIndex",
      "setGalleryChildren",
      "togglePopup",
      "setItemToCollect",
      "closeCollectionsViewer",
      "updateStoreCollection"
      // 'parseMenu'
    ]),
    // initCookieKeyListener() {
    //   window.addEventListener("keydown", this.keydownHandler);
    //   window.addEventListener("keyup", this.keyupHandler);
    // },
    // destroyCookieKeyListener() {
    //   window.removeEventListener("keydown", this.keydownHandler);
    //   window.removeEventListener("keyup", this.keyupHandler);
    // },
    // keyupHandler() {
    //   this.keymap = {};
    // },
    // keydownHandler(e) {
    //   let key = e.key.toLowerCase(),
    //     map = this.keymap;
    //   map[key] = true;
    //   // console.log("map >>> ", this.keymap);
    //   if (map["control"] && map["shift"] && map["arrowdown"]) {
    //     console.log("YAY");
    //     this.shortAcceptCookies = true;
    //     map = {};
    //   }
    // },
    /*
      Check if a local has been set by the user
      and saved in localStorage
    */

    checkLocale(skip, _path) {
      let path = _path || this.$route.fullPath,
        pathQuery = this.$route.query;
      console.log("2222 PATH:", path, " :: ", pathQuery);
      let localeFromQuery = pathQuery.locale;
      let localeFromStorage = storage.get(`MIS-locale`, localStorage);
      let localeFromRoute = this.$route.params.locale;

      if (skip || localeFromStorage) {
        // console.log("current localeString > ", this.localeString);
        // console.log("locale from storage > ", localeFromStorage);
        // console.log("localeFromRoute > ", localeFromRoute);
        this.localeHasBeenSet = true;
        let pathExcludeLocale;

        if (
          /*
            IF not default locale && true locale is not equal to route locale...
          */
          (localeFromRoute && this.localeString !== localeFromRoute) ||
          /*
            IF IS default locale in route but true locale is not default...
          */
          (!localeFromRoute && this.localeString !== this.$defaultLang)
        ) {
          pathExcludeLocale = path.replace(
            new RegExp("/" + localeFromRoute, "g"),
            ""
          );
          // console.log("pathExcludeLocale > ", pathExcludeLocale);
          let localePreface =
              this.localeString !== this.$defaultLang
                ? "/" + this.localeString
                : "",
            _route = `${localePreface}/${pathExcludeLocale}`;

          let finalRoute = _route.replace(/[\/]+/g, "/");
          // if (localeFromQuery) {
          //   // If it was a link with manual locale in query... remove it
          //   finalRoute = finalRoute.split("?")[0];
          // }
          // console.log("finalRoute >> ", finalRoute);
          this.$router.push(finalRoute);
        }
        if (localeFromQuery) {
          // If it was a link with manual locale in query... remove it
          this.$router.replace({ query: null });
        }
      } else {
        this.localeHasBeenSet = false;
      }
    },
    initLocale() {

      let localeFromQuery = this.$route.query;
      let localeFromStorage = storage.get(`MIS-locale`, localStorage);
      console.log("localeFromQuery > ", localeFromQuery);

      let localeFromRoute = this.$route.path;
      console.log("localeFromRoute > ", localeFromRoute);

      if (localeFromQuery && localeFromQuery.locale) {
        console.log("set from query >> ", localeFromQuery.locale);
        this.setLocale(localeFromQuery.locale);
        storage.set(`MIS-locale`, localeFromQuery.locale, localStorage);
        this.checkLocale();
      } 
      else if (localeFromStorage) 
      {
        this.setLocale(localeFromStorage);
      } 
      else 
      {
        //detect langauge by headers of the page
        //page will include a response header with the suggested locale_code according to the location of the client
        this.setLocalizationByLocation();
      }
    },
    setLocalizationByLocation()
    {      
        var vm = this;
        var req = new XMLHttpRequest();
        req.open('GET', document.location, false);
        req.onreadystatechange = function() 
        {
          if(this.readyState == this.DONE) 
          {            
              var locCode = req.getResponseHeader("locale_code");              
              if(locCode!=null && locCode.length>0)
              {
                  //var cCode = req.getResponseHeader("country_code");
                  //cCode = cCode.toLowerCase();
                  //if(cCode=="br"){
                    //Redirect to brazil website
                    //window.location.href = 'https://misimplantes.com.br/';
                  //}else{
                    console.log("---> Setting locale "+locCode);
                    vm.setLocale(locCode);
                    vm.localeHasBeenSet = true;
                  //}
              }else{
                  console.log("---> Setting default locale");
                  vm.setLocale('en');
                  vm.localeHasBeenSet = true;
              }
          }
        }
        req.send(null);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    initResizeListener() {
      // console.log("resize listene");
      window.addEventListener("resize", _.debounce(this.setDimensions, 300));
    },
    initScrollListener() {
      window.addEventListener("scroll", this.scrollHandler, false);
    },
    scrollHandler() {
      this.pageScrollTop = document.documentElement.scrollTop;
      //console.log("scrolling now 3 xxx ...."); //<<<<works only on catalog
    } 
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandler);
    window.removeEventListener("resize", this.setDimensions);
  }
};
</script>

<style>
  .colsX
  {
    clear: both;
    width: 80%;
    margin: auto;
    background-color: #1c1a19;
    min-height: 400px;
    padding: 100px 0px;
  }
  .colsX .c1{
    border:solid 0px red;
    width: 50%;
    display: inline-block;
    vertical-align: middle;
    font-size: 60px;
    padding-right: 5%;
    color:#fff;

  }
  .colsX .c2{
    width: 50%;
    display: inline-block;
    vertical-align: middle;
    padding: 0px 20px;
  }
  .csForm{
    background-color: #fff;
    border-radius: 10px;
    width: 85%;
    min-height: 200px;
    float: right;
  }
  .csForm .title{
    padding: 60px 12%;
    text-align: center;
    font-size: 20px;
    color: #2a2a2a;
  }
  .csForm .csRow{
    clear: both;
    width: 100%;
    padding: 5px 30px;
  }
  .csForm .csRow input{
    border:solid 1px #c9ae9d;
    border-radius: 3px;
    padding: 10px;
    font-size: 14px;
    width: 100%;
  }
  .csForm .csRow .submit-btn{
    background-color: #996748;
    color:#fff;
    font-size: 18px;
    font-weight: bold;
    padding: 10px 20px;
    text-transform: uppercase;
  }
  .csForm .csRow:last-child
  {
    padding-bottom: 50px;
  }

</style>

<style lang="stylus">




body
  // background rgba(#212121, 0.2)
#app
  font-family "Inter", "NimbusSanNovLig W05 Regular", "neue-haas-grotesk-display", Helvetica, Arial, sans-serif
  font-weight normal
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  // text-align center
  color gray_8
  //letter-spacing -0.2px

  *:not([class*="fa"])
    font-family  "Inter", "NimbusSanNovLig W05 Regular", "neue-haas-grotesk-display", Helvetica, Arial, sans-serif
    //font-weight 200
    //letter-spacing -0.2px
  &.de
    //letter-spacing -0.9px
    *:not([class*="fa"])
      //letter-spacing -0.9px
  input
    font-family  "Inter", "NimbusSanNovLig W05 Regular", "neue-haas-grotesk-display", Helvetica, Arial, sans-serif
    letter-spacing -0.2px
  &:not(.hero-menu)
    //padding-top 90px
    +below(815px)
      //padding-top 60px
  .totop
    position fixed
    color blue_4
    right 30px
    bottom 30px
    z-index 1003
    opacity 0.5
    transition opacity 0.3s ease-out
    font-size responsive 16px 30px
    +below(600px)
      opacity 0.8
      transform scale(1.4)
    +desktop()
      &:hover
        opacity 0.8
</style>
